import { Common, color } from '@stockbit/ui';
import Image from 'global/Image';

import { ReloadButton } from './styled';

const { Flex, Text } = Common;

interface FailedLoadProps {
  onReloadClick?(): void;
}

function FailedLoad({ onReloadClick }: FailedLoadProps) {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      px="50px"
      height="100%"
    >
      <Image
        src="/img/load-failed-signal.svg"
        alt="loading-failed"
        width="125px"
      />
      <Text family="bold" align="center" size="16px" mt="20px">
        Failed to Load Running Trade
      </Text>
      <Text align="center" mt="10px" color={color.highgray}>
        Please check your internet connection and try again
      </Text>

      <ReloadButton onClick={onReloadClick}>
        <Image src="/img/reload-white.svg" />
        <Text>Click to Reload</Text>
      </ReloadButton>
    </Flex>
  );
}

export default FailedLoad;
